import I18n from 'I18n';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import _uniqueId from 'hs-lodash/uniqueId';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

// to be able to see alert in modals we need to render
// alerts in body of the document to make z-index work
import { jsx as _jsx } from "react/jsx-runtime";
function GeneralAlert() {
  // clear alerts on unmount
  // need for tests
  useEffect(() => {
    return () => {
      const alerts = FloatingAlertStore.getAlerts();
      Object.keys(alerts).forEach(alert => {
        FloatingAlertStore.removeAlert(alert);
      });
    };
  }, []);
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(FloatingAlertList, {}), document.getElementsByTagName('body')[0]);
}
export const showAlert = payload => {
  const alertId = payload.id || _uniqueId();
  FloatingAlertStore.addAlert({
    message: I18n.text(payload.message),
    titleText: I18n.text(payload.title),
    type: payload.type || 'danger',
    id: alertId,
    timeout: payload.timeout
  });
};
export default GeneralAlert;